import { SERVICE } from '@ds/swymkit/tools'
import { dsFetch } from '@ds/swymkit/tools'
import { servicesAuth } from '@ds/swymkit/tools'
import { removeRequestId } from '@ds/swymkit/tools'
import { serviceProxy } from '@ds/swymkit/tools'

/** Ky instance proxified on LLMInference (AI) service */
export const llmInferenceFetch = dsFetch.extend({
  hooks: {
    beforeRequest: [
      removeRequestId,
      serviceProxy(SERVICE.LLMINFERENCE, 'https://devopsou6jfyj181241-euw1-devprol39-llmi.3dx-staging.3ds.com'),
    ],
    afterResponse: [
      (...args) => servicesAuth(llmInferenceFetch, dsFetch)(...args),
    ],
  },
  timeout: 60000,
})
